var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"day",class:{
    'spacer': _vm.spacer,
    'disabled': _vm.disabled,
    'selected': _vm.selected,
    'occupied': _vm.occupied
  }},[_vm._v(" "+_vm._s(_vm.dayLabels[_vm.day] || _vm.day || '')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }